import React from 'react';
import { authRoles } from 'app/auth';
import RedirectToLastPath from '.';

export const CallbackConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  requireAuthentication: false,
  routes: [
    {
      path: '/callback',
      component: () => <RedirectToLastPath />,
    },
  ],
};
